import { render } from "./GastosIndex.vue?vue&type=template&id=c0f81284"
import script from "./GastosIndex.vue?vue&type=script&lang=js"
export * from "./GastosIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/cruds/GastosIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c0f81284"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c0f81284', __exports__)) {
    api.reload('c0f81284', __exports__)
  }
  
  module.hot.accept("./GastosIndex.vue?vue&type=template&id=c0f81284", () => {
    api.rerender('c0f81284', render)
  })

}


export default __exports__